import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Autorenew from '@material-ui/icons/Autorenew'
import { actualizarDatosParaMuiTable,
  confirmarDefinitivamente }
  from '../camionesSinDefinitiva/actions/TablaCamionesSinDefinitivaActions'
import { connect } from 'react-redux'

function OperacionesCpe (props) {
  const {
    numero,
    confirmarDefinitivamente,
    actualizarDatosParaMuiTable
  } = props
  function onClick () {
    confirmarDefinitivamente(numero).then((result) => {
      console.log('Actualizando', result)
      if (result === undefined) {
        actualizarDatosParaMuiTable()
      }
    })
  }
  return (
    <div>
      <Tooltip title={'Forzar Confirmación Definitiva en ARCA'}>
        <IconButton onClick={() => onClick(numero)}>
          <Autorenew fontSize='default' color='primary' />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const mapActionsToProps = {
  confirmarDefinitivamente,
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(OperacionesCpe)
